export const productInfoCardTokens = {
  colors: {
    text: "#111111",
    textSoft: "rgba(17, 17, 17, 0.72)",
    textMuted: "rgba(17, 17, 17, 0.58)",
    textFaint: "rgba(17, 17, 17, 0.42)",
    border: "rgba(17, 17, 17, 0.08)",
    borderStrong: "rgba(17, 17, 17, 0.12)",
    panel: "#fafafa",
    panelSubtle: "#f7f7f7",
    background: "#ffffff",
    inverseBg: "#111111",
    inverseText: "#ffffff",
    primaryCta: "#2563eb",
    primaryCtaText: "#ffffff",
    shadow: "0 10px 34px rgba(0, 0, 0, 0.06)",
    hoverShadow: "0 8px 22px rgba(0, 0, 0, 0.06)",
    debugPanel: "#f8fafc",
    debugPanelBorder: "rgba(37, 99, 235, 0.14)",
    debugCodeBg: "#0f172a",
    debugCodeText: "#e2e8f0",
  },
  radius: {
    outer: 26,
    panel: 20,
    tile: 16,
    pill: 999,
  },
  spacing: {
    outer: 28,
    gap: 22,
    gapSmall: 14,
    gapTiny: 10,
    panel: 18,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    title: {
      fontSize: 38,
      lineHeight: 1.05,
      fontWeight: 700,
      letterSpacing: "-0.03em",
    },
    subtitle: {
      fontSize: 17,
      lineHeight: 1.6,
      fontWeight: 400,
    },
    sectionTitle: {
      fontSize: 18,
      lineHeight: 1.25,
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    body: {
      fontSize: 15,
      lineHeight: 1.72,
      fontWeight: 400,
    },
    eyebrow: {
      fontSize: 11,
      lineHeight: 1,
      fontWeight: 700,
      letterSpacing: "0.14em",
      textTransform: "uppercase" as const,
    },
    label: {
      fontSize: 13,
      lineHeight: 1.4,
      fontWeight: 600,
    },
    price: {
      fontSize: 28,
      lineHeight: 1.08,
      fontWeight: 700,
    },
    xsmall: {
      fontSize: 11,
      lineHeight: 1.2,
      fontWeight: 700,
      letterSpacing: "0.14em",
      textTransform: "uppercase" as const,
    },
  },
} as const;
